import { getSkinnyAgeButtonsTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";

const skinnyAgeButtonsConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Skinny Age Buttons",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "url",
          label: "URL",
        },
        {
          type: "selectbox",
          name: "count",
          label: "Buttons count",
          items: [
            { value: "3", text: "3" },
            { value: "4", text: "4" },
          ],
        },
        {
          type: "selectbox",
          name: "openLink",
          label: "Open link in...",
          items: [
            { value: "_self", text: "Same window tab" },
            { value: "_blank", text: "New window tab" },
          ],
        },
        {
          type: "colorinput",
          name: "bgColor",
          label: "Button color",
        },
        {
          type: "colorinput",
          name: "hoverColor",
          label: "Hover color",
        },
      ],
    },
    initialData: {
      bgColor: "#28b02b",
      hoverColor: "#28b02b",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getSkinnyAgeButtonsTemplate({
        url: data.url,
        count: data.count,
        tab: data.openLink,
        bgColor: data.bgColor,
        hoverColor: data.hoverColor,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  });
};

export { skinnyAgeButtonsConfig };
